import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "@/app/rootReducer";

interface AdminGuardProps {
  children: React.ReactNode;
}

export default function AdminGuard({ children }: AdminGuardProps) {
  const userAppSettings = useSelector(
    (state: RootState) => state.userAppSettings.userAppSettings,
  );

  const hasAdminRole = userAppSettings?.roles?.includes("ROLE_ADMIN");

  if (!hasAdminRole) {
    return <Navigate replace to="/403" />;
  }

  return <>{children}</>;
}
